import { render, staticRenderFns } from "./h5-WeChat.vue?vue&type=template&id=21c0398a&scoped=true&"
import script from "./h5-WeChat.vue?vue&type=script&lang=js&"
export * from "./h5-WeChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c0398a",
  null
  
)

export default component.exports